module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form-steps-outer"
  }, [_c('div', {
    staticClass: "col-xs-12 center-children-sm"
  }, [_c('div', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.newQuote
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New\n      ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.dataToShow = 'recentJobs'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Recent\n      ")])])]), _vm._v(" "), _c('vuetable', {
    attrs: {
      "showEdit": true,
      "showDelete": true,
      "tableData": _vm.getTableData,
      "tableTitle": _vm.getConst(_vm.locale, 'QUOTES_TABLE'),
      "fields": [{
          header: 'From',
          prop: function (item) { return item.fromLocation ? _vm.displayLocation(item.fromLocation) : ''; }
        },
        {
          header: 'To',
          prop: function (item) { return item.toLocation ? _vm.displayLocation(item.toLocation) : ''; }
        },
        {
          header: 'Container Type',
          prop: 'containerType'
        },
        {
          header: 'Account',
          prop: function (item) { return item.account ? _vm.displayParty(item.account) : ''; }
        }
      ]
    },
    on: {
      "table-delete-request": _vm.handleDelete,
      "table-edit-request": _vm.handleEdit
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn btn-primary"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filter\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ecb1c23"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/quote/components/QuoteSearch.vue
// module id = 2199
// module chunks = 1